
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale/index.js'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales =
    require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.js$/i)

  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key).default
    }
  })
  return messages
}

const i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

// 实现element插件的多语言切换
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
